import React, { useState } from 'react';
import './OnboardingOptionCard.css';
import './OnboardingSummaryCard.css';
import './OnboardingInvitationCard.css';

// "Your school has added some questions." Shown below the onboarding
// transcript when GET /api/onboarding/state serves an invitation (the user's
// set has a step they never answered and they have not said "Not now" to
// it). A UI card only, never a stored message.
//
// onAccept(): starts the redo (and reloads the panel). onDismiss(): records
// "Not now" (and refetches state, which removes this card). Both return
// promises; a rejection keeps the card and shows a short error under it.
function OnboardingInvitationCard({ text, onAccept, onDismiss }) {
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState('');

  const run = async (which, action, failure) => {
    setBusy(which);
    setError('');
    try {
      await action();
    } catch (_) {
      setError(failure);
    } finally {
      setBusy(null);
    }
  };

  return (
    <section className="onboarding-card onboarding-invitation-card" aria-label="New questions">
      <p className="onboarding-invitation-text">{text}</p>
      {error ? <p className="onboarding-invitation-error" role="alert">{error}</p> : null}
      <div className="onboarding-card-foot onboarding-invitation-foot">
        <button
          type="button"
          className="onboarding-btn-quiet"
          disabled={busy !== null}
          onClick={() => run('dismiss', onDismiss, 'Could not hide this. Please try again.')}
        >
          {busy === 'dismiss' ? 'Hiding…' : 'Not now'}
        </button>
        <button
          type="button"
          className="onboarding-btn-primary"
          disabled={busy !== null}
          onClick={() => run('accept', onAccept, 'Could not start the questions. Please try again.')}
        >
          {busy === 'accept' ? 'Starting…' : 'Answer them now'}
        </button>
      </div>
    </section>
  );
}

export default OnboardingInvitationCard;
